const state = {
  courseList: []
}
const getters = {
	getCourseList(state) {
		return state.courseList
	},
}
const mutations = {
  setCourseList(state, list) {
		state.courseList = list
	},
}
const actions = {
}
export default{
	namespaced:true,
	state,
	getters,
	mutations,
	actions
}
